import { FC, useEffect, useState } from "react";
import { Form, FormControlProps } from "react-bootstrap";
import RequiredField from "./required-field";
import { PiEyeClosedLight, PiEyeLight } from "react-icons/pi";
import * as Yup from "yup";

interface SimplePasswordFieldProps extends FormControlProps {
  isShowVisibilityIcon?: boolean;
  required?: boolean;
  error?: string;
  label?: string;
  validationSchema?:
    | Yup.StringSchema
    | Yup.NumberSchema
    | Yup.ObjectSchema<any>;

  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
}

const SimplePasswordField: FC<SimplePasswordFieldProps> = ({
  isShowVisibilityIcon,
  label,
  required,
  error,
  onChange,
  onBlur,
  validationSchema,
  ...props
}) => {
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const [validationMessage, setValidationMessage] = useState<string>(null);

  useEffect(() => {
    if (error) {
      setValidationMessage(error);
    }
  }, [error]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (validationSchema) {
      try {
        validationSchema.validateSync(event.target.value.trim());
        setValidationMessage(null);
      } catch (error) {
        setValidationMessage(error.message);
      }
    }

    onChange?.(event);
  };

  const handleBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    if (!required && event.target.value.trim().localeCompare("") === 0) {
      setValidationMessage(null);
    }

    onBlur?.(event);
  };

  return (
    <Form.Group className="form-group">
      <Form.Label>
        {label ?? "Password"} {required && <RequiredField />}
      </Form.Label>
      <Form.Control
        type={isVisible ? "text" : "password"}
        required={required}
        isInvalid={!!validationMessage}
        onBlur={handleBlur}
        onChange={handleChange}
        {...props}
      />
      {isShowVisibilityIcon && (
        <span
          className="toggle-password"
          style={{
            right: validationMessage ? "2rem" : "1rem",
            top: validationMessage ? "14%" : "20%",
          }}
          onClick={() => setIsVisible(!isVisible)}
        >
          {isVisible ? <PiEyeClosedLight /> : <PiEyeLight />}
        </span>
      )}
      <Form.Control.Feedback type="invalid">
        {validationMessage}
      </Form.Control.Feedback>
    </Form.Group>
  );
};

export default SimplePasswordField;
